import { Card } from '@statsbomb/kitbag-components';

import { useAtomValue, useSetAtom } from 'jotai';
import { Suspense, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { teamEventMarkersDescriptionsAtom, teamEventMarkersForMetricAtom } from '@/atoms/queries/team/teamEventData';
import { unwrappedSelectedTeamNameAtom } from '@/atoms/team/info';
import { teamIdAtom } from '@/atoms/team/team';
import { VideoPlayerPanelBodyBase } from '@/components/video/VideoPlayerPanel';
import { METRIC_KEY, TEAM_ID } from '@/consts/searchKeys';
import { useSetTeamDataDebouncedFilterParams } from '@/hooks/apiFilterParams/useSetTeamDataDebounceFilterParams';
import { useEntityVideoPlayerPanelHeader } from '@/hooks/useEntityVideoPlayerPanelHeader';
import { useFormatVideoEvents } from '@/hooks/useFormatVideoEvents';
import { useMetricKeyFilter } from '@/hooks/useMetricKeyFilter';
import { useVideoDataFromEventMarkers } from '@/hooks/useVideoDataFromEventMarkers';

const TeamVideoPlayerPanelBodyWithData = () => {
  useSetTeamDataDebouncedFilterParams();
  const [searchParams] = useSearchParams();
  const metricKeyParam = searchParams.get(METRIC_KEY);
  const teamIdParam = searchParams.get(TEAM_ID);
  const {
    videoIds,
    unavailableVideosCount,
    ref,
    isLoading: isLoadingUnavailableCount,
  } = useVideoDataFromEventMarkers<HTMLSpanElement>(teamEventMarkersForMetricAtom);
  const videoEventMarkersDescriptions = useAtomValue(teamEventMarkersDescriptionsAtom);
  const videoEvents = useFormatVideoEvents(videoIds, videoEventMarkersDescriptions);

  const setPlayerId = useSetAtom(teamIdAtom);
  const { setMetricKey } = useMetricKeyFilter();

  useEffect(() => {
    if (teamIdParam && metricKeyParam) {
      setPlayerId(Number(teamIdParam));
      setMetricKey(metricKeyParam);
    }
  }, [teamIdParam, metricKeyParam]);

  return (
    <span ref={ref}>
      <VideoPlayerPanelBodyBase
        isLoading={isLoadingUnavailableCount || !teamIdParam || !metricKeyParam}
        videoEvents={videoEvents}
        unavailableVideosCount={unavailableVideosCount}
      />
    </span>
  );
};

const TeamVideoPlayerPanelBody = () => (
  <Suspense fallback={<VideoPlayerPanelBodyBase videoEvents={[]} isLoading />}>
    <TeamVideoPlayerPanelBodyWithData />
  </Suspense>
);

export const TeamDataLockerVideoPreview = () => {
  useEntityVideoPlayerPanelHeader(unwrappedSelectedTeamNameAtom, TEAM_ID);

  return (
    <Card>
      <TeamVideoPlayerPanelBody />
    </Card>
  );
};
